import axiosPublicClient from "../../../../axiosPublicClient"

export default async (payload) => {
    const result = await axiosPublicClient.post(`/get-candidate-consumer-report`, payload)
    return result.data
}
